(() => {
  'use strict';
  function start() {
    document.querySelectorAll('.pcba-article').forEach(article => {
      if (article.dataset.pcbTocReady) return;
      article.dataset.pcbTocReady = 'true';
      const content = article.querySelector('.pcba-article__content');
      const nav = article.querySelector('[data-pcb-article-toc-auto]');
      if (!content || !nav) return;
      const supplied = content.querySelector('[data-pcb-article-toc]');
      if (!supplied) {
        const headings = Array.from(content.querySelectorAll('h2')).filter(h => h.textContent.trim());
        if (headings.length >= 3) {
          const list = nav.querySelector('ol');
          headings.forEach((heading, index) => {
            if (!heading.id) {
              const base = article.id + '-section-' + (index + 1);
              let identity = base;
              let suffix = 2;
              while (document.getElementById(identity)) identity = base + '-' + suffix++;
              heading.id = identity;
            }
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.href = '#' + encodeURIComponent(heading.id);
            link.textContent = heading.textContent.trim();
            item.appendChild(link);
            list.appendChild(item);
          });
          nav.hidden = false;
        }
      }
      (supplied || nav).querySelectorAll('a[href^="#"]').forEach(link => {
        let identity;
        try { identity = decodeURIComponent(link.getAttribute('href').slice(1)); } catch { return; }
        const heading = document.getElementById(identity);
        if (!heading) return;
        link.addEventListener('click', () => {
          heading.tabIndex = -1;
          requestAnimationFrame(() => heading.focus({preventScroll:true}));
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
